import { HTTPError } from "ky";
import { AjaxError } from "../ajax-error";

export class BadRequestException extends AjaxError {
  constructor(
    response: Response,
    request: Request,
    options: HTTPError["options"]
  ) {
    super(400, response, request, options);
    this.name = "BadRequestException";
  }

  getUserFriendlyMessage(): string {
    return this.message || "La richiesta non è valida. Controlla i dati inseriti e riprova.";
  }
}